<div class="card mb-3">
  <div class="card-body">
    <div class="row g-2 align-items-end">
      <div class="col-sm-4">
        <label class="form-label mb-1">Start day</label>
        <input class="form-control" type="date" [(ngModel)]="startDayFilter" [disabled]="isLoading">
      </div>
      <div class="col-sm-4">
        <label class="form-label mb-1">End day</label>
        <input class="form-control" type="date" [(ngModel)]="endDayFilter" [disabled]="isLoading">
      </div>
      <div class="col-sm-4 d-flex gap-2">
        <button class="btn btn-sm btn-primary" type="button" (click)="refresh()" [disabled]="isLoading">
          <i class="fa fa-filter"></i> Filter
        </button>
        <button class="btn btn-sm btn-danger" type="button" (click)="onClickResetFilters()" [disabled]="isLoading">
          <i class="fa fa-ban"></i> Reset
        </button>
        <button class="btn btn-sm btn-secondary ms-auto" type="button" (click)="refresh()" [disabled]="isLoading">
          <i class="fa fa-refresh"></i> Refresh
        </button>
      </div>
    </div>
  </div>
</div>

@if (isLoading) {
  <div class="card">
    <div class="card-body text-center text-muted py-4">
      <i class="fa fa-spinner fa-spin"></i> Loading...
    </div>
  </div>
} @else if (isLoaded) {
  <div class="row g-2 mb-3">
    <div class="col-12 col-md-4">
      <div class="card text-white text-center mb-0" [ngClass]="pricePercentDaySeven >= 0 ? 'bg-success' : 'bg-danger'">
        <div class="card-body py-2 px-2">
          <div class="text-uppercase" style="font-size: 0.7rem;">Last 7 days vs previous 7 days</div>
          <div class="fw-bold mb-0" style="font-size: 1.3rem;">{{ pricePercentDaySeven > 0 ? '+' : '' }}{{ pricePercentDaySeven | percent:'1.0-2' }}</div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="card text-white text-center mb-0" [ngClass]="pricePercentDayThirty >= 0 ? 'bg-success' : 'bg-danger'">
        <div class="card-body py-2 px-2">
          <div class="text-uppercase" style="font-size: 0.7rem;">Last 30 days vs previous 30 days</div>
          <div class="fw-bold mb-0" style="font-size: 1.3rem;">{{ pricePercentDayThirty > 0 ? '+' : '' }}{{ pricePercentDayThirty | percent:'1.0-2' }}</div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="card bg-primary text-white text-center mb-0">
        <div class="card-body py-2 px-2">
          <div class="text-uppercase" style="font-size: 0.7rem;">Revenue since start of month</div>
          <div class="fw-bold mb-0" style="font-size: 1.3rem;">{{ priceTotalCurrentMonth | number:'1.0-2' }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-header">
      <i class="fa fa-line-chart"></i> Price total
    </div>
    <div class="card-body">
      @if (totalPriceChartData.labels?.length) {
        <div class="row g-2 mb-3">
          <div class="col-6 col-md-4">
            <div class="card bg-success text-white text-center mb-0">
              <div class="card-body py-1 px-2">
                <div class="text-uppercase" style="font-size: 0.7rem;">Average</div>
                <div class="fw-bold mb-0" style="font-size: 1.1rem;">{{ totalPriceAverage }}</div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-4">
            <div class="card bg-info text-white text-center mb-0">
              <div class="card-body py-1 px-2">
                <div class="text-uppercase" style="font-size: 0.7rem;">Max</div>
                <div class="fw-bold mb-0" style="font-size: 1.1rem;">{{ totalPriceMax }}</div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-4">
            <div class="card bg-warning text-white text-center mb-0">
              <div class="card-body py-1 px-2">
                <div class="text-uppercase" style="font-size: 0.7rem;">Min</div>
                <div class="fw-bold mb-0" style="font-size: 1.1rem;">{{ totalPriceMin }}</div>
              </div>
            </div>
          </div>
        </div>
        <div style="position: relative; height: 350px; width: 100%; overflow: hidden;">
          <c-chart type="line" [data]="totalPriceChartData" [options]="totalPriceChartOptions" style="position: absolute; inset: 0;"></c-chart>
        </div>
      } @else {
        <div class="text-center text-muted py-4">No data available.</div>
      }
    </div>
  </div>

  <div class="card mt-4">
    <div class="card-header">
      <i class="fa fa-line-chart"></i> Packages price total
    </div>
    <div class="card-body">
      @if (packagesPriceChartData.datasets?.length) {
        <div style="position: relative; height: 350px; width: 100%; overflow: hidden;">
          <c-chart type="line" [data]="packagesPriceChartData" [options]="packagesPriceChartOptions" style="position: absolute; inset: 0;"></c-chart>
        </div>
      } @else {
        <div class="text-center text-muted py-4">No data available.</div>
      }
    </div>
  </div>

  <div class="card mt-4">
    <div class="card-header">
      <i class="fa fa-line-chart"></i> Packages count
    </div>
    <div class="card-body">
      @if (packagesCountChartData.datasets?.length) {
        <div style="position: relative; height: 350px; width: 100%; overflow: hidden;">
          <c-chart type="line" [data]="packagesCountChartData" [options]="packagesCountChartOptions" style="position: absolute; inset: 0;"></c-chart>
        </div>
      } @else {
        <div class="text-center text-muted py-4">No data available.</div>
      }
    </div>
  </div>
}
